exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".uhqm-sidebar {\n  position: relative;\n  position: sticky;\n}", ""]);

